var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.24,
    height: 7.477,
    viewBox: "0 0 12.24 7.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M12.305,16.47,7.677,11.521a.832.832,0,0,0-1.235,0,.989.989,0,0,0,0,1.324l5.244,5.607a.833.833,0,0,0,1.206.027l5.281-5.63a.986.986,0,0,0,0-1.324.832.832,0,0,0-1.235,0Z",
    transform: "translate(-6.188 -11.246)",
    fill: "#B98772"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.340b2cb9a22ef940fa1be4b08b793cb4.svg";
export { ForwardRef as ReactComponent };